export default "__VITE_ASSET__7YYBjl17__"